import { useEffect, useState } from "react";

const HEX = "0123456789abcdef";
const rnd = (n) => Array.from({ length: n }, () => HEX[Math.floor(Math.random() * 16)]).join("");

export const CipherStream = ({ samples }) => {
  const [i, setI] = useState(0);
  const [cipher, setCipher] = useState(rnd(32));
  useEffect(() => {
    const scr = setInterval(() => setCipher(rnd(32)), 90);
    const nx = setInterval(() => setI((x) => (x + 1) % samples.length), 2600);
    return () => { clearInterval(scr); clearInterval(nx); };
  }, [samples.length]);
  return (
    <div data-testid="cipher-stream" className="font-mono text-[11px] sm:text-xs border border-[#3f454c] bg-black/40 backdrop-blur-md p-4 space-y-1.5 shadow-[0_0_40px_rgba(224,38,44,0.15)]">
      <div className="flex gap-2"><span className="text-[#6b7280] w-20 shrink-0">input</span><span className="text-white">"{samples[i]}"</span></div>
      <div className="flex gap-2"><span className="text-[#6b7280] w-20 shrink-0">cipher</span><span className="text-[#E0262C]">TLS · HTTPS</span></div>
      <div className="flex gap-2"><span className="text-[#6b7280] w-20 shrink-0">output</span><span className="text-[#34d399] break-all">{cipher}</span></div>
      <div className="flex items-center gap-2 pt-1 text-[10px] uppercase tracking-widest text-[#a9afb5]">
        <span className="w-1.5 h-1.5 rounded-full bg-[#34d399] animate-pulse" /> Swiss data · 256-bit
      </div>
    </div>
  );
};
